/**
 * 获取资源文案
 * @param ext 资源类型
 */
export const getFileByExt = (file) => {
    var _a;
    const ext = (file.name || ((_a = file.url) !== null && _a !== void 0 ? _a : '')).split('.').reverse()[0].toLowerCase();
    switch (ext) {
        case 'mp3':
        case 'mp4':
        case 'mov':
        case 'avi':
        case 'mpg':
        case 'mpeg':
        case 'm2v':
        case 'mkv':
        case 'wma':
        case 'wmv':
        case 'ram':
        case 'rmvb':
        case 'rm':
        case 'flv':
        case 'swf':
            return {
                title: '视频',
                type: EnFileType.VIDEO,
                defaultIconName: '',
                defaultSvg: 'VideoSvg',
                bg: '',
            };
        case 'apng':
        case 'avif':
        case 'ai':
        case 'bmp':
        case 'cdr':
        case 'dxf':
        case 'eps':
        case 'emf':
        case 'exif':
        case 'ico':
        case 'jpg':
        case 'jpeg':
        case 'gif':
        case 'fpx':
        case 'png':
        case 'pcx':
        case 'psd':
        case 'pcd':
        case 'raw':
        case 'svg':
        case 'tga':
        case 'tif':
        case 'tiff':
        case 'webp':
        case 'wmf':
        case 'ufo':
            return {
                title: '图片',
                type: EnFileType.IMG,
                defaultIconName: 'PictureOutlined',
                defaultSvg: 'OtherSvg',
                bg: '',
            };
        case 'xlsx':
        case 'xls':
            return {
                title: '表格',
                type: EnFileType.XLS,
                defaultIconName: '',
                defaultSvg: 'ExcelSvg',
                bg: '',
            };
        // case 'ppt':
        // case 'pptx':
        //   return {
        //     title: 'ppt',
        //     type: EnFileType.PPT,
        //     defaultIconName: '',
        //     defaultSvg: '',
        //     bg: '',
        //   }
        case 'doc':
        case 'docx':
            return {
                title: '文档',
                type: EnFileType.WORD,
                defaultIconName: '',
                defaultSvg: 'WordSvg',
                bg: '',
            };
        case 'pdf':
            return {
                title: 'pdf',
                type: EnFileType.PDF,
                defaultIconName: '',
                defaultSvg: 'PdfSvg',
                bg: '',
            };
        case 'zip':
        case 'rar':
        case 'tgz':
            return {
                title: '压缩文件',
                type: EnFileType.ZIP,
                defaultIconName: '',
                defaultSvg: 'ZipSvg',
                bg: '',
            };
        default:
            return {
                title: '其他',
                type: EnFileType.OTHER,
                defaultIconName: 'FileOutlined',
                defaultSvg: 'OtherSvg',
                bg: '',
            };
    }
};
export var EnFileType;
(function (EnFileType) {
    EnFileType["IMG"] = "img";
    EnFileType["VIDEO"] = "video";
    EnFileType["OFFICE"] = "office";
    EnFileType["PPT"] = "ppt";
    EnFileType["WORD"] = "word";
    EnFileType["XLS"] = "xls";
    EnFileType["PDF"] = "pdf";
    EnFileType["ZIP"] = "zip";
    EnFileType["OTHER"] = "other";
})(EnFileType || (EnFileType = {}));
export const getVideoFirstFrameByUrl = (url) => {
    return new Promise((resolve, reject) => {
        const video = document.createElement('video');
        video.setAttribute('crossOrigin', 'anonymous');
        video.setAttribute('src', url);
        // video.setAttribute('preload', 'auto')
        // video.setAttribute('autoplay', 'true');
        video.setAttribute('muted', 'true');
        video.setAttribute('playsinline', 'true');
        video.setAttribute('webkit-playsinline', 'true');
        video.currentTime = 0.1;
        video.addEventListener('loadeddata', function () {
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const ctx = canvas.getContext('2d');
            ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            resolve(canvas.toDataURL());
        });
        video.addEventListener('error', function () {
            reject();
        });
    });
};
